module.exports = __webpack_public_path__ + "static/media/greentech.299888e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/logos_2024/greentech.png
// module id = 823
// module chunks = 0